import React from 'react'
import { useSelector } from 'hooks/use-redux'
import { Link } from 'react-router-dom'
import { isDeviceTypePhone } from '@disco/state-management/selectors/app'
import {
  getIsTrial,
  getTrialLeftSelector,
} from '@disco/state-management/selectors/business'
import Alert from 'components/ui/alert'
export const useShowExplorerTrialAlert = (): boolean => {
  const isPhone = useSelector(isDeviceTypePhone)
  const isTrial = useSelector(getIsTrial)
  if (!isPhone || !isTrial) return false
  return true
}

/**
 * Trial alert component for explorer interface on mobile devices
 * Shows subscription prompt with trial days remaining
 */
const ExplorerTrialAlert = (): React.ReactNode => {
  const trialLeft = useSelector(getTrialLeftSelector)
  return (
    <Alert status="info">
      {trialLeft.message}{' '}
      <Link className="text-link" to="/settings/billing">
        Subscribe
      </Link>
    </Alert>
  )
}

export default ExplorerTrialAlert
